import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-maquinas-reporte-movimiento",
  templateUrl: "./maquinas-reporte-movimiento.component.html",
  styleUrls: ["./maquinas-reporte-movimiento.component.scss"],
})
export class MaquinasReporteMovimientoComponent implements OnInit {
  constructor() {}

  optionsEstadoActual: Array<any> = [];

  ngOnInit() {
    this.optionsEstadoActual = [
      { value: "1", label: "Estado 1" },
      { value: "2", label: "Estado 2" },
      { value: "3", label: "Estado 3" },
    ];
  }
}
